"use client"

import { useEffect } from "react"

const APP_ID = process.env.NEXT_PUBLIC_INSTANTDB_APP_ID || ""
const IS_MOCK_MODE = !APP_ID || APP_ID === "placeholder_app_id"

/**
 * SessionProvider for InstantDB Auth
 *
 * In mock mode, this just wraps children without any InstantDB calls.
 * In production mode, it would use InstantDB for auth context.
 */
export function SessionProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    sessionStorage.setItem("app-session-active", "true")
    
    if (IS_MOCK_MODE) {
      // In mock mode, just set basic session info
      return () => {
        sessionStorage.removeItem("app-session-active")
      }
    }

    const handleBeforeUnload = () => {
      try {
        const userEmail = sessionStorage.getItem("user-email") || localStorage.getItem("user-email")
        if (userEmail && userEmail.toLowerCase() === "gelowushu@gmail.com") {
          return
        }
      } catch (error) {
        console.error("Error in beforeunload handler:", error)
      }
    }

    const handleVisibilityChange = () => {
      if (document.hidden) {
        sessionStorage.setItem("tab-hidden-time", Date.now().toString())
      }
    }

    window.addEventListener("beforeunload", handleBeforeUnload)
    document.addEventListener("visibilitychange", handleVisibilityChange)

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload)
      document.removeEventListener("visibilitychange", handleVisibilityChange)
      sessionStorage.removeItem("app-session-active")
    }
  }, [])

  return <>{children}</>
}
